import { render, staticRenderFns } from "./people.vue?vue&type=template&id=e7f874ee&scoped=true&"
import script from "./people.vue?vue&type=script&lang=js&"
export * from "./people.vue?vue&type=script&lang=js&"
import style0 from "@assets/css/resource/people.less?vue&type=style&index=0&id=e7f874ee&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7f874ee",
  null
  
)

component.options.__file = "people.vue"
export default component.exports